import { StateCreator } from "zustand";
import {
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
  AUTH_HEADER,
} from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchUserReturnPosType } from "../../../domain/models/user-return-acknowledgement/user-return-pos";
import { FetchUserReturnPos } from "../../../domain/useages/user-return-acknowledgement/fetch-user-return-pos";
import { RemoteFetchUserReturnAcknowledgement } from "../../../data/usecases/user-return-acknowledgement/remote-fetch-user-return-acknowledgement";

export interface fetchUserReturnPosSliceInterface {
  FetchUserReturnPos: FetchUserReturnPosType;
  FetchUserReturnPosState: FetchState;
  fetchUserReturnPos: Function;
}

const initialStates = {
  FetchUserReturnPos: {} as FetchUserReturnPosType,
  FetchUserReturnPosState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchUserReturnAcknowledgementSlice: StateCreator<
  fetchUserReturnPosSliceInterface
> = (set) => ({
  ...initialStates,
  fetchUserReturnPos: async (filter: FetchUserReturnPos.Params) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchUserReturnAcknowledgement =
      new RemoteFetchUserReturnAcknowledgement(
        `${BASE_URL}${Endpoints.FETCH_USER_RETURN_ACKNOWLEDGEMENT}`,

        axiosHttpClient
      );

    set(() => ({ FetchUserReturnPosState: FetchState.LOADING }));
    let result = await remoteFetchUserReturnAcknowledgement.fetch(filter);
    return result;
  },
});
